import React__default, { useEffect } from 'react';
import classnames from 'classnames';
import { DataLayer } from '@grandvisionhq/analytics';
import { LocationSearch } from '@grandvisionhq/locations';
import { useAddViewportHeightCssVariable } from '@grandvisionhq/utils';
import { storesSearchFilterEvent } from '../../data-layer/actions.js';
import useStoreSearchFilters from '../../hooks/use-store-search-filters.js';
import { useTabs } from '../../hooks/use-tabs.js';
import StoreFinderFilterWarning from '../StoreFinderFilterWarning/StoreFinderFilterWarning.js';
import StoreGroupFinderItem from '../StoreFinderItem/StoreFinderItemContainer.js';
import StoreFinderMapContainer from '../StoreFinderMap/StoreFinderMapContainer.js';
import StoreListTopContentFallback from '../StoreListTopContentFallback/StoreListTopContentFallback.js';
import StoreSearchFilters from '../StoreSearchFilters/StoreSearchFilters.js';
import StoreSearchFormContainer from '../StoreSearchForm/StoreSearchFormContainer.js';
import { useStoreFinderContext } from '../../context/StoreFinder/context.js';
import { useStoreFinderSlots } from '../../context/StoreFinderSlots/context.js';

const StoreFinderContainer = ({ isInsideModal , listTopContent , listInfoContent , listItemComponent , infoWindowContentComponent , buttonsComponent , storeSearchFilters: propStoreSearchFilters , highlightPreferredStore , className , showAttributesAsTags ,  })=>{
    const { isStoresLoading , stores , config , setHoveredStore  } = useStoreFinderContext();
    const showTabs = useTabs();
    const { Slots  } = useStoreFinderSlots();
    const [{ setFilterActivity , applyActiveFilters , clearAllFilters  }, { storeSearchFilters , storeSearchFilterList , hasActiveFilters , loading , activeFilters  }, ] = useStoreSearchFilters({
        filters: propStoreSearchFilters
    });
    const { googleMapsId  } = config;
    const prevActiveFilters = React__default.useRef([]);
    const showListTopContent = Boolean(listTopContent);
    const showListInfoContent = Boolean(listInfoContent);
    const ButtonsComponent = buttonsComponent;
    const onMouseEnterHandler = React__default.useCallback((store)=>setHoveredStore(store)
    , [
        setHoveredStore
    ]);
    const onMouseLeaveHandler = React__default.useCallback(()=>setHoveredStore(null)
    , [
        setHoveredStore
    ]);
    const ListItemComponent = listItemComponent !== null && listItemComponent !== void 0 ? listItemComponent : StoreGroupFinderItem;
    const filteredStores = React__default.useMemo(()=>applyActiveFilters(stores)
    , [
        stores,
        applyActiveFilters
    ]);
    useEffect(()=>{
        if (prevActiveFilters.current.length !== activeFilters.length) {
            prevActiveFilters.current = activeFilters;
            const dataLayerEvent = storesSearchFilterEvent({
                activeFilters,
                searchResults: filteredStores.length
            });
            DataLayer.pushEvent(dataLayerEvent);
        }
    }, [
        activeFilters
    ]);
    // Add css variable var(--vh) to document
    useAddViewportHeightCssVariable();
    return /*#__PURE__*/ React__default.createElement(LocationSearch, {
        className: classnames('store-finder-stores-v2', className, {
            'store-finder-stores-v2--modal': isInsideModal
        }),
        googleMapsId: googleMapsId,
        showTabs: showTabs,
        searchForm: /*#__PURE__*/ React__default.createElement(StoreSearchFormContainer, {
            queryResultsFilters: (stores === null || stores === void 0 ? void 0 : stores.length) ? /*#__PURE__*/ React__default.createElement(StoreSearchFilters, {
                filters: storeSearchFilterList,
                setFilterActivity: setFilterActivity
            }) : null
        }),
        listTopContent: /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, (Slots === null || Slots === void 0 ? void 0 : Slots.SideComponents) ? /*#__PURE__*/ React__default.createElement(Slots.SideComponents, null) : null, showListTopContent ? listTopContent : /*#__PURE__*/ React__default.createElement(StoreListTopContentFallback, null)),
        listInfoContent: showListInfoContent ? listInfoContent : /*#__PURE__*/ React__default.createElement(StoreFinderFilterWarning, {
            applyActiveFilters: applyActiveFilters,
            clearAllFilters: clearAllFilters,
            hasActiveFilters: hasActiveFilters
        }),
        loadingListItems: isStoresLoading,
        listItems: filteredStores.map((store)=>/*#__PURE__*/ React__default.createElement(ListItemComponent, {
                loading: loading,
                key: store.code,
                store: store,
                buttons: ButtonsComponent ? /*#__PURE__*/ React__default.createElement(ButtonsComponent, {
                    store: store,
                    view: "list"
                }) : undefined,
                onMouseEnter: onMouseEnterHandler,
                onMouseLeave: onMouseLeaveHandler,
                showAttributesAsTags: showAttributesAsTags
            })
        ),
        mapContent: /*#__PURE__*/ React__default.createElement(StoreFinderMapContainer, {
            stores: filteredStores,
            infoWindowContentComponent: infoWindowContentComponent,
            buttonsComponent: ButtonsComponent,
            showAttributesAsTags: showAttributesAsTags
        }),
        highlightPreferredStore: highlightPreferredStore
    });
};
var StoreFinderContainer$1 = StoreFinderContainer;

export { StoreFinderContainer$1 as default };
//# sourceMappingURL=StoreFinderContainer.js.map
